import ClasImpl from '@/serviceImpl/ClasImpl';
import {DashboardData, FilterGroup} from '@/domain/services/Clas';
import {getCredentialsOrThrow} from '@/domain/useCases/getCredentialsOrThrow';

const getDashboardDataUseCase = async (filterGroup: FilterGroup, year?: number): Promise<DashboardData | undefined> => {
  const accessToken = getCredentialsOrThrow();

  if(!year) return;

  try {
    return await ClasImpl.getDashboardData(year, filterGroup, accessToken);
  } catch (error) {
    console.error('Error fetching projects', error);
    throw error;
  }

};

export default getDashboardDataUseCase;